module.exports = __webpack_public_path__ + "static/media/ios-cloud-download.11442ba2.svg";